import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
const ResetPassword = Loadable(lazy(() => import('views/pages/authentication/authentication3/ResetPassword')));
const CompleteReset = Loadable(lazy(() => import('views/pages/authentication/authentication3/CompleteReset')));
const CreditApplicationPage = Loadable(lazy(() => import('views/pages/credit-app/CreditApplicationPage')));
const CreditApplicationSigningPage = Loadable(lazy(() => import('views/pages/credit-app/CreditApplicationSigningPage')));
const ReferenceFormPage = Loadable(lazy(() => import('views/pages/reference-form/ReferenceFormPage')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/login',
      element: <AuthLogin3 />
    },
    {
      path: '/register',
      element: <AuthRegister3 />
    },
    {
      path: '/reset-password',
      element: <ResetPassword />
    },
    {
      path: '/complete-password-reset',
      element: <CompleteReset />
    },
    {
      path: '/credit-app/:orgGuid',
      element: <CreditApplicationPage />
    },
    {
      path: '/credit-app/:orgGuid/sign/:customerId',
      element: <CreditApplicationSigningPage />
    },
    {
      path: '/reference/:guid',
      element: <ReferenceFormPage />
    }
  ]
};

export default AuthenticationRoutes;
